"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MedicationKnowledge = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_MedicationKnowledge_RelatedMedicationKnowledge_1 = require("./RTTI_MedicationKnowledge_RelatedMedicationKnowledge");
var RTTI_MedicationKnowledge_Monograph_1 = require("./RTTI_MedicationKnowledge_Monograph");
var RTTI_MedicationKnowledge_Ingredient_1 = require("./RTTI_MedicationKnowledge_Ingredient");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var RTTI_MedicationKnowledge_Cost_1 = require("./RTTI_MedicationKnowledge_Cost");
var RTTI_MedicationKnowledge_MonitoringProgram_1 = require("./RTTI_MedicationKnowledge_MonitoringProgram");
var RTTI_MedicationKnowledge_AdministrationGuidelines_1 = require("./RTTI_MedicationKnowledge_AdministrationGuidelines");
var RTTI_MedicationKnowledge_MedicineClassification_1 = require("./RTTI_MedicationKnowledge_MedicineClassification");
var RTTI_MedicationKnowledge_Packaging_1 = require("./RTTI_MedicationKnowledge_Packaging");
var RTTI_MedicationKnowledge_DrugCharacteristic_1 = require("./RTTI_MedicationKnowledge_DrugCharacteristic");
var RTTI_MedicationKnowledge_Regulatory_1 = require("./RTTI_MedicationKnowledge_Regulatory");
var RTTI_MedicationKnowledge_Kinetics_1 = require("./RTTI_MedicationKnowledge_Kinetics");
exports.RTTI_MedicationKnowledge = t.recursion('IMedicationKnowledge', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('MedicationKnowledge')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            code: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            status: RTTI_code_1.RTTI_code,
            _status: RTTI_Element_1.RTTI_Element,
            manufacturer: RTTI_Reference_1.RTTI_Reference,
            doseForm: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            amount: RTTI_Quantity_1.RTTI_Quantity,
            synonym: t.array(t.string),
            _synonym: t.array(RTTI_Element_1.RTTI_Element),
            relatedMedicationKnowledge: t.array(RTTI_MedicationKnowledge_RelatedMedicationKnowledge_1.RTTI_MedicationKnowledge_RelatedMedicationKnowledge),
            associatedMedication: t.array(RTTI_Reference_1.RTTI_Reference),
            productType: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            monograph: t.array(RTTI_MedicationKnowledge_Monograph_1.RTTI_MedicationKnowledge_Monograph),
            ingredient: t.array(RTTI_MedicationKnowledge_Ingredient_1.RTTI_MedicationKnowledge_Ingredient),
            preparationInstruction: RTTI_markdown_1.RTTI_markdown,
            _preparationInstruction: RTTI_Element_1.RTTI_Element,
            intendedRoute: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            cost: t.array(RTTI_MedicationKnowledge_Cost_1.RTTI_MedicationKnowledge_Cost),
            monitoringProgram: t.array(RTTI_MedicationKnowledge_MonitoringProgram_1.RTTI_MedicationKnowledge_MonitoringProgram),
            administrationGuidelines: t.array(RTTI_MedicationKnowledge_AdministrationGuidelines_1.RTTI_MedicationKnowledge_AdministrationGuidelines),
            medicineClassification: t.array(RTTI_MedicationKnowledge_MedicineClassification_1.RTTI_MedicationKnowledge_MedicineClassification),
            packaging: RTTI_MedicationKnowledge_Packaging_1.RTTI_MedicationKnowledge_Packaging,
            drugCharacteristic: t.array(RTTI_MedicationKnowledge_DrugCharacteristic_1.RTTI_MedicationKnowledge_DrugCharacteristic),
            contraindication: t.array(RTTI_Reference_1.RTTI_Reference),
            regulatory: t.array(RTTI_MedicationKnowledge_Regulatory_1.RTTI_MedicationKnowledge_Regulatory),
            kinetics: t.array(RTTI_MedicationKnowledge_Kinetics_1.RTTI_MedicationKnowledge_Kinetics)
        })
    ]);
});
//# sourceMappingURL=RTTI_MedicationKnowledge.js.map